import { useEffect, useState } from "react";
import {
  getData,
  getDataById,
  insertData,
  deleteData,
} from "../../../../utils/fetch";

import css from "./index.module.css";
import Loading from "../../../../components/Loading";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import PsychologyIcon from '@mui/icons-material/Psychology';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";


/**
 * Display the list of available challenges.
 * Each Challange is colorcoded respectivley 
 * for the given class-grade and is either 
 * selected or can be selected. A change in
 * selection is stored in the db.
 * @param {String} classId 64 character uuid of the given class
 * @param {Number} classGrade the grade of the class
 */
const ChallengeList = ({ classId, classGrade }) => {
  const [temp, setTemp] = useState([]);
  const [challenges, setChallenges] = useState(null);
  const [selectedChallenges, setSelectedChallenges] = useState(null);

  useEffect(() => {
    getData("/api/challenges").then((data) => setChallenges(data));
    getDataById("/api/classToChallenges/byId", { classId: classId }).then((data) => {
      setSelectedChallenges(data);
    });
  }, [classId]);

  useEffect(() => {
    if (challenges) {
      const newTemp = [];
      challenges?.forEach((e) => {
        let isSelected = false;
        selectedChallenges?.forEach((s) => {
          if (s.challenge_id === e.id) {
            isSelected = true;
          }
        });
        newTemp.push({
          id: e.id,
          name: e.name,
          isSelected: isSelected,
          recommendation: e.recommended_grade,
        });
      });
      setTemp(newTemp);
    }
  }, [challenges, selectedChallenges]);

  /**
   * changes the selection of an Challenge for an class 
   * @param {boolean} newSelection whether the prior selection was true or false
   * @param {string} id 64 character uuid of the given challenge
   */
  const handleChangeSelection = (newSelection, id) => {
    if (newSelection) {
      insertData("/api/classToChallenges", {
        classId: classId,
        challengeId: id,
      }).then(() => {
        getDataById("/api/classToChallenges/byId", { classId: classId }).then(
          (data) => {
            setSelectedChallenges(data);
          }
        );
      });
    } else {
      deleteData("/api/classToChallenges", { classId: classId, challengeId: id }).then(
        () => {
          getDataById("/api/classToChallenges/byId", { classId: classId }).then(
            (data) => {
              setSelectedChallenges(data);
            }
          );
        }
      );
    }
  };

  /**
   * determines the classname and henceforth the color of a given challenge
   * @param {*} recommendation the recommended grade of the challenge
   * @returns css.easyRecommendation || css.mediumRecommendation || css.hardRecommendation
   */
  const handleRecommendedColor = (recommendation) => {
    if (classGrade >= recommendation) {
      return "#3b8631";
    } else if (classGrade + 2 >= recommendation) {
      return "#866831";
    } else {
      return "#863131";
    }
  };

  return (
    <div className={css.card}>
      {temp?.length === 0 ? (
        <Loading />
      ) : (
        <div className={css.challenges}>
          {temp?.map((e) => {
            return (
              <div key={"challengelistChallenge_" + e.id} className={css.challenge}>
                <div className={css.challengeItem}>
                  <span>{"Challenge " + e.name}</span>
                  <div className={css.icons}>
                    <div className={css.recommendation}>
                      <PsychologyIcon style={{fill:handleRecommendedColor(e.recommendation), fontSize: "35px"}}/>
                    </div>
                    {e.isSelected ? (
                      <CheckBoxIcon
                        onClick={() => handleChangeSelection(false, e.id)}
                      />
                    ) : (
                      <CheckBoxOutlineBlankIcon
                        onClick={() => handleChangeSelection(true, e.id)}
                      />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ChallengeList;
